// @flow

import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import $ from 'jquery'
import ModalEnterCode from './ModalEnterCode'
import imgAppStore from '../../images/astronaut/appstore.png'
import imgGooglePlay from '../../images/astronaut/gplay.png'
import initializers from '../../dependencies/initializers'
import bindAll from 'lodash/bindAll'
import {accesslog, getOSInfo , translate } from '../../helpers/global'
import { getWeeklyDemoDataAsync } from '../../actions/global'
import AstrntLogoWhite from '../../styles/img/astro-logo-white.svg?v=1'
import appleButton from '../../styles/img/mobile-app/apple.jpg'
import googleButton from '../../styles/img/mobile-app/google.jpg'
import imgIsoLogo from '../../images/iso-logo.png'

type Props = {};

class FooterNew2 extends React.Component<Props> {


	constructor(props) {
		super(props)
		this.state = {
		angleClass: 'fa-angle-down',
		langHide:'hide',
		langHideMobile:'hide',
		};
		this.footerLangContainerRef = React.createRef();
		this.footerLangContainerRefMobile = React.createRef();

		bindAll(this, [
			'handleDropDeadClick',
			'handleDropDeadClickMobile',
			'detectClick',
		])
	}

	chooseOpt(val) {
		const url_api = initializers.api_host
		  if(val === '1') {
			  if (process.env.NODE_ENV === 'development') {
				window.location = 'http://localhost:3000/'
			} else if (url_api == 'https://beta.astrnt.co') {
	
				window.location = 'https://test.astrnt.co/'
	
			} else {
				window.location = 'https://astrnt.co/'
			}
		  } else {
			  if (process.env.NODE_ENV === 'development') {
				window.location = 'http://localhost:3000/'
			} else if (url_api == 'https://beta.astrnt.co') {
	
				window.location = 'https://test.astrnt.id/'
	
			} else {
				window.location = 'https://astrnt.id/'
			}
		  }
		}

	handleDropDeadClick(e){
		if (this.state.langHide == 'hide') {
			this.setState({
				angleClass: 'fa-angle-up',
				langHide:'',
			})
		}else{
			this.setState({
				angleClass: 'fa-angle-down',
				langHide:'hide',
			})
		}
	}

	handleDropDeadClickMobile(e){
		if (this.state.langHideMobile == 'hide') {
			this.setState({
				angleClass: 'fa-angle-up',
				langHideMobile:'',
			})
		}else{
			this.setState({
				angleClass: 'fa-angle-down',
				langHideMobile:'hide',
			})
		}
	}

  handleEnterCodeClick(e: Object) {
  	e.preventDefault()

  	$('#modalEnterCode').modal('show')
  }

  componentDidMount()
  {
    $('ul.footer-dropdown li a.dropdown-footer').click(function(event){
        event.preventDefault();
        
        if(!$(this).hasClass('is-on')){
            $(this).addClass('is-on').parent().find('div').slideDown('fast');
        }else{
            $(this).removeClass('is-on').parent().find('div').slideUp('fast');
        }
    });

	window.addEventListener("click", this.detectClick)

	// Only fetch if weeklyDemoData is empty or not loaded yet
	if (!this.props.weeklyDemoData || !this.props.weeklyDemoData.title) {
		this.props.getWeeklyDemoDataAsync();
	}

  }

  detectClick(event){
	if (this.footerLangContainerRef.current != null) {
		if (!this.footerLangContainerRef.current.contains(event.target)) {
			this.setState({
				angleClass: 'fa-angle-down',
				langHide:'hide',
			})
		}
	}
	if (this.footerLangContainerRefMobile.current != null) {
		if (!this.footerLangContainerRefMobile.current.contains(event.target)) {
			this.setState({
				angleClass: 'fa-angle-down',
				langHideMobile:'hide',
			})
		}
	}
}


  render() {

	const {
		globalGetLanguages,
		weeklyDemoData
	} = this.props

    return(
    	<Fragment>
				<footer className="desktop-hide">
	          <section>
	            <ul>
	            	<li id="footer-first-li">
	            	  <img src={AstrntLogoWhite} />
	            	  {translate(globalGetLanguages,'FOOTER_AUTOMATION')}
	            	  <ul className="for-soc">
	                  <li>
	                    <a href="https://www.facebook.com/astrnt.co" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook" /></a>
	                  </li><li>
	                    <a href="https://www.youtube.com/c/astrntco" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube" /></a>
	                  </li><li>
	                    <a href="https://www.linkedin.com/company/astrnt-co" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin" /></a>
	                  </li><li>
	                    <a href="https://www.instagram.com/astrnt.co/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram" /></a>
	                  </li>
	                </ul>
	            	</li>
	              <li>
				  ASTRNT
	                <ul>
	                  <li><Link to={'/talent-acquisition/astrnt-platform/ai-structured-video-interview'}>AI Interview</Link></li>
	                  <li><Link to={'/talent-acquisition/skill-validation'}>Skill Validation</Link></li>
	                  <li className={`${weeklyDemoData && weeklyDemoData.webinar_link && weeklyDemoData.webinar_link.trim() !== '' ? '' : 'hide'}`}>
						<a href={weeklyDemoData && weeklyDemoData.webinar_link ? weeklyDemoData.webinar_link : '#'} target="_blank" rel="noopener noreferrer"
							onClick={() => accesslog('footer', 'button_get_a_demo')}
						>Get a Demo</a>
	                  </li>
	                  <li><Link to={'/features'}>Features</Link></li>
	                </ul>
	              </li>
	              <li>
				  Solutions & Use Cases
	                <ul>
	                  <li><Link to={'/nextgen-assessment-center'}>NextGen Assessment Center</Link></li>
	                  <li><Link to={'/nextgen-rpo'}>NextGen RPO</Link></li>
	                  <li><Link to={'/talent-acquisition/graduate'}>Graduate</Link></li>
	                  <li><Link to={'/talent-acquisition/professional'}>Professional</Link></li>
	                  <li><Link to={'/talent-acquisition/technical'}>Technical</Link></li>
	                  <li><Link to={'/talent-acquisition/hourly'}>Hourly</Link></li>
	                </ul>
	              </li>
	              <li>
				  &nbsp;
	                <ul>
	                  <li><Link to={'/talent-management/internal-mobility'}>Internal Mobility</Link></li>
	                  <li><Link to={'/talent-management/talent-mapping'}>Talent Mapping</Link></li>
	                  <li><Link to={'/talent-management/succession-planning'}>Succession Planning</Link></li>
	                  <li><Link to={'/talent-management/high-potential-identification'}>High Potential Identification</Link></li>
	                  <li><Link to={'/admissions'}>Admissions</Link></li>
	                  <li><Link to={'/career-center'}>Career Center</Link></li>
	                </ul>
	              </li>
	              <li>
				  Company
	                <ul>
	                  {/* <li><Link to={`/enter-code`}>Enter Code</Link></li> */}
	                  {/* <li><Link to={'/'}>Legal Center (coming soon)</Link></li> */}
	                  <li><Link to={`/about`}>About Us</Link></li>
	                  <li><a href="https://astrnt.co/p/talentpool" rel="noopener noreferrer" target="_blank">Careers</a></li>
	                  <li><a href={`${initializers.dev_host}/api-documentation`} target="_blank" rel="noopener noreferrer">{translate(globalGetLanguages,'FOOTER_API_DOC')}</a></li>
	                  <li><Link to={'/partners'}>Partners</Link></li>
	                </ul>
	              </li>
	            </ul>
	          </section>
	          <div className="the-copy">
	          	<section ref={this.footerLangContainerRef} className="under-footer">
				  	<div className="under-footer-link">
						<Link to={'/termsofservice'}>Term of Use</Link>
						<Link to={'/privacypolicy'}>Privacy</Link>
						{/* <Link to={'/'}>AI Ethical Principles</Link> */}
						{/* <Link to={'/'}>Data Processing Agreement</Link> */}
					</div>
	            	<span>© Astronaut Technologies Pte Ltd. All rights reserved.</span>
	            </section>
	          </div>
        </footer>
        <footer className="mobile-hide">
	          <section>
	            <ul className="footer-dropdown">
	            	<li>
	            	  <img src={AstrntLogoWhite} />
					  {translate(globalGetLanguages,'FOOTER_AUTOMATION')}
	            	  <ul className="for-soc">
	                  <li>
	                    <a href="https://www.facebook.com/astrnt.co" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook" /></a>
	                  </li><li>
	                    <a href="https://www.youtube.com/c/astrntco" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube" /></a>
	                  </li><li>
	                    <a href="https://www.linkedin.com/company/astrnt-co" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin" /></a>
	                  </li><li>
	                    <a href="https://www.instagram.com/astrnt.co/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram" /></a>
	                  </li>
	                </ul>
	            	</li>
	              <li>
	              	<a className="dropdown-footer" href="#">
					  ASTRNT
	              	  <i className="fa fa-angle-down" />
	              	</a>
	              	<div style={{display: 'none'}}>
		                <ul>
							<li><Link to={'/talent-acquisition/astrnt-platform/ai-structured-video-interview'}>AI Interview</Link></li>
							<li><Link to={'/talent-acquisition/skill-validation'}>Skill Validation</Link></li>
							<li className={`${weeklyDemoData && weeklyDemoData.webinar_link && weeklyDemoData.webinar_link.trim() !== '' ? '' : 'hide'}`}>
								<a href={weeklyDemoData && weeklyDemoData.webinar_link ? weeklyDemoData.webinar_link : '#'} target="_blank" rel="noopener noreferrer"
									onClick={() => accesslog('footer', 'button_get_a_demo')}
								>Get a Demo</a>
							</li>
							<li><Link to={'/features'}>Features</Link></li>
		                </ul>
	               	</div>
	              </li>
	              <li>
	              	<a className="dropdown-footer" href="#">
					  Solutions & Use Cases
	              	  <i className="fa fa-angle-down" />
	              	</a>
	              	<div style={{display: 'none'}}>
		                <ul>
							<li><Link to={'/nextgen-assessment-center'}>NextGen Assessment Center</Link></li>
							<li><Link to={'/nextgen-rpo'}>NextGen RPO</Link></li>
							<li><Link to={'/talent-acquisition/graduate'}>Graduate</Link></li>
							<li><Link to={'/talent-acquisition/professional'}>Professional</Link></li>
							<li><Link to={'/talent-acquisition/technical'}>Technical</Link></li>
							<li><Link to={'/talent-acquisition/hourly'}>Hourly</Link></li>
							<li><Link to={'/talent-management/internal-mobility'}>Internal Mobility</Link></li>
							<li><Link to={'/talent-management/talent-mapping'}>Talent Mapping</Link></li>
							<li><Link to={'/talent-management/succession-planning'}>Succession Planning</Link></li>
							<li><Link to={'/talent-management/high-potential-identification'}>High Potential Identification</Link></li>
							<li><Link to={'/admissions'}>Admissions</Link></li>
							<li><Link to={'/career-center'}>Career Center</Link></li>
	                	</ul>
	                </div>
	              </li>
	              <li>
	              	<a className="dropdown-footer" href="#">
					  {translate(globalGetLanguages,'COMPANY')}
	              	  <i className="fa fa-angle-down" />
	              	</a>
	              	<div style={{display: 'none'}}>
		                <ul>
							{/* <li><Link to={'/'}>Legal Center (coming soon)</Link></li> */}
							<li><Link to={`/about`}>About Us</Link></li>
							<li><a href="https://astrnt.co/p/talentpool" rel="noopener noreferrer" target="_blank">Careers</a></li>
							<li><a href={`${initializers.dev_host}/api-documentation`} target="_blank" rel="noopener noreferrer">{translate(globalGetLanguages,'FOOTER_API_DOC')}</a></li>
							<li><Link to={'/partners'}>Partners</Link></li>
		                </ul>
		              </div>
	              </li>
	            </ul>
	          </section>
	          <div className="the-copy">
	          	<section ref={this.footerLangContainerRef} className="under-footer">
				  	<div className="under-footer-link">
						<Link to={'/termsofservice'}>Term of Use</Link>
						<Link to={'/privacypolicy'}>Privacy</Link>
						{/* <Link to={'/'}>AI Ethical Principles</Link> */}
						{/* <Link to={'/'}>Data Processing Agreement</Link> */}
					</div>
	            	<span>© Astronaut Technologies Pte Ltd. All rights reserved.</span>
	            </section>
	          </div>
        </footer>
      </Fragment>
		)
  }
}

const mapStateToProps = (state) => {
	return{ 
	  globalGetLanguages:state.globalGetLanguages,
	  weeklyDemoData: state.weeklyDemo.weeklyDemoData,
	}
	
  }

const mapDispatchToProps = (dispatch) => {
	return {
		getWeeklyDemoDataAsync: () => dispatch(getWeeklyDemoDataAsync())
	}
}

export default connect(mapStateToProps, mapDispatchToProps )(FooterNew2)

